export const MODAK_SCHEME = 'modak://';
export const MODAK_DEVELOPMENT_SCHEME = 'modak-development://';
import {isProduction} from './environment';

const modakScheme = isProduction ? MODAK_SCHEME : MODAK_DEVELOPMENT_SCHEME;

export const buildDeeplink = (path: string) => {
  return `${modakScheme}${path}`;
};
